import { faCalendarDays, faListOl, faUsers } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Header/Actions/AbandonedBookingsHeaderActions.module.scss';
import { AbandonedBookingsAddButton } from 'components/Bookings2/Abandoned/Header/Actions/AddButton/AbandonedBookingsAddButton';
import { CalendarFilter } from 'components/UI';
import { SelectDropdown } from 'components/UI/V2/SelectDropdown/SelectDropdown';
import { OnlineBookingStep, OnlineBookingStepNames } from 'model/OnlineBooking';
import React from 'react';

const stepOptions = Object.values(OnlineBookingStep).map(step => ({
    id: step,
    label: OnlineBookingStepNames[step]
}));

interface AbandonedBookingsHeaderActionsProps {
    className?: string;
}

export const AbandonedBookingsHeaderActions: React.FC<AbandonedBookingsHeaderActionsProps> = ({ className }) => {
    const {
        selectedSteps,
        setSelectedSteps,
        clientFilterOptions,
        selectedClientFilters,
        setSelectedClientFilters,
        datePeriod,
        setDatePeriod
    } = useAbandonedBookings();

    return (
        <div className={clsx(styles.root, className)}>
            <SelectDropdown
                multiple
                label="Steps"
                value={selectedSteps}
                options={stepOptions}
                buttonProps={{
                    size: 'large',
                    variant: 'outlined',
                    leftIcon: faListOl,
                    rightIcon: undefined,
                    hideLabelOnMobile: true,
                    className: styles.actionButton
                }}
                onChange={steps => setSelectedSteps(steps.map(step => step as OnlineBookingStep))}
            />

            <SelectDropdown
                multiple
                label="Clients"
                value={selectedClientFilters}
                options={clientFilterOptions.map(option => ({
                    id: option.id,
                    label: option.name
                }))}
                buttonProps={{
                    size: 'large',
                    variant: 'outlined',
                    leftIcon: faUsers,
                    rightIcon: undefined,
                    hideLabelOnMobile: true,
                    className: styles.actionButton
                }}
                onChange={clients => setSelectedClientFilters(clients.map(client => client as string))}
            />

            <CalendarFilter
                hideUpcoming
                hideTomorrow
                hideNext7Days
                optionSelected="Today"
                period={datePeriod}
                buttonIcon={faCalendarDays}
                className={styles.datePicker}
                onChange={setDatePeriod}
            />

            <AbandonedBookingsAddButton className={clsx(styles.onlyDesktop, styles.actionButton)} />
        </div>
    );
};
